<template>
  <div>
    <PageHeader :navigation="[]" :alternate-languages="[]" />
    <div class="page-hero grid gap-x-6 gap-y-10 max-w-full relative pb-20 md:pt-14 lg:pt-32">
      <section class="md:container grid gap-6">
        <div class="boxed boxed-content px-box-4 pt-box-4 border-t-4 border-brand-600">
          <div class="typography no-top-spacing">
            <h1 class="title mb-6 sm:mb-8 md:mb-9 lg:mb-11">
              {{ $t('errors.something_went_wrong') }}...
            </h1>
            <template v-if="$isPreview">
              <p class="mt-8">{{ error.statusCode }} {{ error.message }}</p>
              <div
                v-if="error.stack"
                class="mt-6 bg-gray-100 p-4 rounded-6 overflow-auto"
                v-html="error.stack"
              />
            </template>
            <p>{{ $t('errors.not_found') }}</p>
          </div>
          <ul class="mt-10 lg:grid lg:grid-cols-3 lg:grid-rows-1 lg:gap-6">
            <li v-for="(item, index) in items" :key="index" class="py-2 lg:py-0">
              <a
                class="h-full rounded-8 transition-all overflow-hidden duration-300 ease-in-out hover:opacity-80 py-2 flex flex-row hover:shadow-2 lg:block lg:py-0 lg:shadow-1"
                :href="item.link"
              >
                <div class="w-12 h-12 lg:w-full lg:h-auto shrink-0">
                  <BackgroundImage
                    class="bg-brand-500 h-full rounded-8 lg:rounded-none lg:pt-[50%]"
                    :src="item.image"
                    :lazy="false"
                  />
                </div>
                <div class="mx-4 lg:mb-5 lg:mt-4">
                  <p class="font-bold text-18 lg:text-28 lg:mb-1.5">{{ item.title }}</p>
                  <p class="font-medium text-12 text-gray-500">{{ item.subtitle }}</p>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </section>
    </div>
    <ClientOnly>
      <ImtSearchModal />
    </ClientOnly>
  </div>
</template>

<script lang="ts" setup>
import { getPageView } from '@core/analytics/pages'

defineProps<{ error: { statusCode: number; message: string; stack: string } }>()

const { $t, $isPreview, $track } = useNuxtApp()

const items = computed(() =>
  [
    {
      title: $t(`links.title_imt`),
      subtitle: $t(`links.subtitle_imt`),
      link: $t(`links.link_imt`),
      image:
        'https://monito-cms.imgix.net/dfaca309-940f-4ea5-a56f-c21ecca3e960_product-grid-imt.png?auto=compress,format&w=800&h=400',
    },
    {
      title: $t(`links.title_neobank`),
      subtitle: $t(`links.subtitle_neobank`),
      link: $t(`links.link_neobank`),
      image:
        'https://monito-cms.imgix.net/a15e4dde-23e3-47ae-8f60-bc4ae2dd28db_product-grid-neobank.png?auto=compress,format&w=800&h=400',
    },
    {
      title: $t(`links.title_airtime`),
      subtitle: $t(`links.subtitle_airtime`),
      link: $t(`links.link_airtime`),
      image:
        'https://monito-cms.imgix.net/35469727-d3a6-4ddd-8186-4a5ca41954d9_product-grid-airtime.png?auto=compress,format&w=800&h=400',
    },
    {
      title: $t(`links.title_abroad`),
      subtitle: $t(`links.subtitle_abroad`),
      link: $t(`links.link_abroad`),
      image:
        'https://monito-cms.imgix.net/bc7ee2eb-3255-4840-8087-49f4327fc08c_product-grid-abroad.png?auto=compress,format&w=800&h=400',
    },
    {
      title: $t(`links.title_insurance`),
      subtitle: $t(`links.subtitle_insurance`),
      link: $t(`links.link_insurance`),
      image:
        'https://monito-cms.imgix.net/f9d14fc9-9ed1-4994-ad96-b6cbf6c40e6a_product-grid-insurance.png?auto=compress,format&w=800&h=400',
    },
    {
      title: $t(`links.title_about`),
      subtitle: $t(`links.subtitle_about`),
      link: $t(`links.link_about`),
      image:
        'https://monito-cms.imgix.net/0cc52647-23b8-4f1b-9f12-ee7add309039_product-grid-about.png?auto=compress,format&w=800&h=400',
    },
  ].filter((item) => item.link.trim()),
)

onMounted(async () => {
  await $track(getPageView(useRoute()))
})
</script>
